import React, { Component } from "react";
import DefaultFieldsFilter from "./DefaultFieldsFilter";
import CustomFieldsFilter from "./CustomFieldsFilter";
import QueryGroups from "./QueryGroups";
import TaxonomiesFilter from "./TaxonomiesFilter";
import { Tabs } from "@adrianoferreira/wp-react-admin";
import {FieldGroupContext} from "../../../../../contexts/FieldGroupContext";
import Output from "./Output";
import Ordering from "./Ordering";
import OffsetLimit from "./OffsetLimit";

export const DisplayData = (props) => {

	return(
		<div id="poststuff" className="display-data-box">
			<div id="slugdiv" className="postbox">
				<h2 className="hndle ui-sortable-handle"><span>Display Posts Data</span></h2>
				<div className="inside" style={{display: 'block'}}>

					<p>This action should be used whenever you want to output posts as well as post custom fields.</p>

						{props.endpoint.displayData.map(
							(el, index) =>

									<FieldGroupContext.Provider key={index} value={{
										action: 'displayData',
										currentItem: index,
										endpointId: props.id,
										endpoint: props.endpoint
									}}>

									<Tabs tabs={[
										{
											name:    'defaultFields',
											title:   'Default Fields Filter',
											content: <DefaultFieldsFilter group={'defaultFields'} key={index + '-defaultFields'}/>
										},
										{
											name: 'customFields',
											title: 'Custom Fields Filter',
											content: <CustomFieldsFilter key={index + '-customFields'} group={'customFields'}/>
										},
										{
											name: 'taxonomies',
											title: 'Taxonomies Filter',
											content: <TaxonomiesFilter key={index + '-taxonomies'} group={'taxonomies'}/>
										},
										{
											name: 'orderby',
											title: 'Ordering',
											content: <Ordering key={index + '-ordering'} action='displayData'/>
										},
										{
											name: 'limit-offset',
											title: 'Limit and Offset (Pagination)',
											content: <OffsetLimit key={index + '-limit-offset'}/>
										},
										{
											name: 'queryGroups',
											title: 'Query Groups',
											content: <QueryGroups key={index + '-queryGroups'} group={'queryGroups'}/>
										},
										{
											name: 'output',
											title: 'Output',
											content: <Output key={index + '-output'} group={'output'}/>
										},
									]} />

								</FieldGroupContext.Provider>
						)}

				</div>
			</div>
		</div>
	)
};
